/**
 * The below file contains the constants used in the root
 * @author: neeraj.singh.rawat@velsof.com
 * @date : 18-01-2023
 */

export const RESET_REDUCER = "RESET_REDUCER";
